import { render, staticRenderFns } from "./order_obsolete_record.vue?vue&type=template&id=036314fc&scoped=true&"
import script from "./order_obsolete_record.vue?vue&type=script&lang=js&"
export * from "./order_obsolete_record.vue?vue&type=script&lang=js&"
import style0 from "./order_obsolete_record.vue?vue&type=style&index=0&id=036314fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036314fc",
  null
  
)

export default component.exports